import classes from "./OgxAbout.module.css";
import globalVolunteerLogo from "../../Assets/Images/gv2.svg";
import globalTeacherLogo from "../../Assets/Images/globalTeacher.svg";
import globalTalentLogo from "../../Assets/Images/globalTalent.svg";

const OgxAbout = () => {
  const bars = [
    {
      color: "#F85A40",
      logo: globalVolunteerLogo,
      label: "Global Volunteer",
      text: "Short-term volunteering on a social project. Open to students.",
    },
    {
      color: "#F48924",
      logo: globalTeacherLogo,
      label: "Global Teacher",
      text: "Teaching placement in a classroom abroad. Graduates only.",
    },
    {
      color: "#0CB9C1",
      logo: globalTalentLogo,
      label: "Global Talent",
      text: "Paid professional internship abroad. Graduates only.",
    },
  ];

  return (
    <section className={classes.container}>
      <svg
        className={classes.decoration}
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="61"
        viewBox="0 0 67 91"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M65.3143 1.51892C45.8033 14.1921 26.3642 29.0193 6.19136 37.9941C-1.61964 41.4691 2.8786 44.5426 8.14952 44.3529C19.0594 43.9602 30.3039 40.1752 41.2862 39.0293C44.4537 38.6987 57.4561 36.1045 49.3635 43.527C43.3028 49.086 12.189 71.8156 29.7199 69.5127C44.597 67.5585 36.4429 77.5015 34.9024 89.8194"
          stroke="#037EF3"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      <h2 className={classes.heading}>What is Outgoing Global Exchange?</h2>

      <p className={classes.paragraph}>
        Outgoing Global Exchange (OGX) is an AIESEC experience that gives young
        Nigerians the opportunity to travel abroad, gain practical experience,
        develop new skills, and experience different cultures. Through
        opportunities such as Global Volunteer, Global Talent, and Global
        Teacher, you can step outside your comfort zone, connect with people
        from around the world, and grow personally and professionally while
        creating meaningful impact.
      </p>

      <div className={classes.bars}>
        {bars.map((bar, i) => (
          <div
            className={classes.bar}
            key={i}
            style={{ backgroundColor: bar.color }}
          >
            <img
              className={classes.barLogo}
              src={bar.logo}
              alt={`${bar.label} logo`}
              loading="lazy"
            />
            <span className={classes.barText}>{bar.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OgxAbout;
